<template>
  <el-dialog
    :title="$t('store::album::edit_添加商品')"
    :close-on-click-modal="false"
    :visible.sync="skuVisible"
    width="690px"
  >
    <el-row>
      <el-col :span="14" style="border-right: 1px solid #dcdfe6;padding: 0 24px">
        <div class="search-wrap">
          <el-input
            :placeholder="$t('storage::out-stock::add_input')"
            v-model="keyword"
            style="width:80%;"
            @keyup.enter.native="search"
          >
            <el-select
              v-model="selectType"
              slot="prepend"
              :placeholder="$t('storage::out-stock::add_select')"
              style="width: 110px"
            >
              <el-option label="SPU" value="spuId"></el-option>
              <el-option :label="$t('store::album::edit_商品名称')" value="title"></el-option>
            </el-select>
          </el-input>
          <div>
            <span style="margin-right:8px;color:#666">{{ $t('system::common::btn::selecAll') }}</span>
            <el-checkbox :value="checkSelectAll" @change="selectAll"></el-checkbox>
          </div>
        </div>
        <div>
          <ul class="ul-list">
            <li v-for="item in searchList" :key="item.spuId" class="sku-item">
              <div style="width: 85%" class="sku-title">
                <ZImg class="image" :src="item.spuImg"></ZImg>
                <div style="margin-left: 10px">
                  <p>{{ item.spuId }}</p>
                  <p class="one-line" style="width: 240px">
                    {{ item.title }}
                  </p>
                </div>
              </div>
              <el-checkbox :value="list.some(i => i.spuId === item.spuId)" @change="chooseItem(item)"></el-checkbox>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="10">
        <ul class="ul-list" style="height:410px;padding:0 24px;">
          <li v-for="item in list" :key="item.spuId" class="sku-item">
            <div class="sku-title">
              <ZImg class="image" :src="item.spuImg"></ZImg>
              <div style="margin-left: 10px">
                <p>{{ item.spuId }}</p>
                <p class="one-line" style="width: 140px">
                  {{ item.title }}
                </p>
              </div>
            </div>
            <i class="el-icon-circle-close" style="font-size: 20px;color:#999;" @click="remove(item)"></i>
          </li>
        </ul>
      </el-col>
    </el-row>
    <div slot="footer" style="text-align:center;">
      <el-button size="small" @click="skuVisible = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button size="small" type="primary" @click="addGoods">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getGoodsList } from '@/server/album.js'
export default {
  props: {
    value: {},
    goodsList: {
      type: Array,
      require: true
    },
    shopId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      skuVisible: this.value,
      list: [],
      keyword: '',
      selectType: 'spuId',
      searchList: []
    }
  },
  watch: {
    value(val) {
      this.skuVisible = val
      if (val) {
        this.getGoodsList()
        this.list = [...this.goodsList]
      } else {
        this.list = []
        this.keyword = ''
      }
    },
    goodsList(val) {
      this.list = [...val]
    },
    skuVisible(val) {
      this.$emit('input', val)
    }
  },
  computed: {
    checkSelectAll() {
      let i = 0
      this.searchList.forEach(el => {
        this.list.forEach(item => {
          if (item.spuId === el.spuId) {
            i++
          }
        })
      })
      return i === this.searchList.length && this.searchList.length !== 0
    }
  },
  methods: {
    search() {
      if (this.selectType === 'spuId') {
        this.getGoodsList({ spuId: this.keyword })
      } else if (this.selectType === 'title') {
        this.getGoodsList({ title: this.keyword })
      }
    },
    addGoods() {
      this.skuVisible = false
      this.$emit('addGoods', this.list)
    },
    chooseItem(item) {
      let flag = false
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].spuId === item.spuId) {
          this.list.splice(i, 1)
          flag = true
          break
        }
      }
      if (!flag) {
        this.list.push(item)
      }
    },
    selectAll(value) {
      if (value) {
        this.list = [...this.searchList.filter(i => !this.list.some(item => i.spuId === item.spuId)), ...this.list]
      } else {
        this.list = this.list.filter(i => !this.searchList.some(item => i.spuId === item.spuId))
      }
    },
    remove(item) {
      this.list = this.list.filter(i => i.spuId !== item.spuId)
    },
    async getGoodsList(params) {
      const { data } = await getGoodsList({ ...params, shopId: this.shopId })
      if (data.code === this.$code) {
        this.searchList = data.data.map(el => {
          return {
            ...el,
            spuId: el.id
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog .el-dialog__body {
  padding: 24px 0px;
}
.search-wrap {
  padding-bottom: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sku-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
  cursor: pointer;
}
.image {
  width: 43px;
  height: 43px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.sku-title {
  display: flex;
  align-items: center;
}
.ul-list {
  height: 350px;
  overflow: auto;
}
</style>
